export const codes: any = {
  "Ascension Island": {
    "code": "AC",
    "unicode": "U+1F1E6 U+1F1E8",
    "name": "Ascension Island",
    "emoji": "🇦🇨"
  },
  "Andorra": {
    "code": "AD",
    "unicode": "U+1F1E6 U+1F1E9",
    "name": "Andorra",
    "emoji": "🇦🇩"
  },
  "United Arab Emirates": {
    "code": "AE",
    "unicode": "U+1F1E6 U+1F1EA",
    "name": "United Arab Emirates",
    "emoji": "🇦🇪"
  },
  "Afghanistan": {
    "code": "AF",
    "unicode": "U+1F1E6 U+1F1EB",
    "name": "Afghanistan",
    "emoji": "🇦🇫"
  },
  "Antigua & Barbuda": {
    "code": "AG",
    "unicode": "U+1F1E6 U+1F1EC",
    "name": "Antigua & Barbuda",
    "emoji": "🇦🇬"
  },
  "Anguilla": {
    "code": "AI",
    "unicode": "U+1F1E6 U+1F1EE",
    "name": "Anguilla",
    "emoji": "🇦🇮"
  },
  "Albania": {
    "code": "AL",
    "unicode": "U+1F1E6 U+1F1F1",
    "name": "Albania",
    "emoji": "🇦🇱"
  },
  "Armenia": {
    "code": "AM",
    "unicode": "U+1F1E6 U+1F1F2",
    "name": "Armenia",
    "emoji": "🇦🇲"
  },
  "Angola": {
    "code": "AO",
    "unicode": "U+1F1E6 U+1F1F4",
    "name": "Angola",
    "emoji": "🇦🇴"
  },
  "Antarctica": {
    "code": "AQ",
    "unicode": "U+1F1E6 U+1F1F6",
    "name": "Antarctica",
    "emoji": "🇦🇶"
  },
  "Argentina": {
    "code": "AR",
    "unicode": "U+1F1E6 U+1F1F7",
    "name": "Argentina",
    "emoji": "🇦🇷"
  },
  "American Samoa": {
    "code": "AS",
    "unicode": "U+1F1E6 U+1F1F8",
    "name": "American Samoa",
    "emoji": "🇦🇸"
  },
  "Austria": {
    "code": "AT",
    "unicode": "U+1F1E6 U+1F1F9",
    "name": "Austria",
    "emoji": "🇦🇹"
  },
  "Australia": {
    "code": "AU",
    "unicode": "U+1F1E6 U+1F1FA",
    "name": "Australia",
    "emoji": "🇦🇺"
  },
  "Aruba": {
    "code": "AW",
    "unicode": "U+1F1E6 U+1F1FC",
    "name": "Aruba",
    "emoji": "🇦🇼"
  },
  "Åland Islands": {
    "code": "AX",
    "unicode": "U+1F1E6 U+1F1FD",
    "name": "Åland Islands",
    "emoji": "🇦🇽"
  },
  "Azerbaijan": {
    "code": "AZ",
    "unicode": "U+1F1E6 U+1F1FF",
    "name": "Azerbaijan",
    "emoji": "🇦🇿"
  },
  "Bosnia & Herzegovina": {
    "code": "BA",
    "unicode": "U+1F1E7 U+1F1E6",
    "name": "Bosnia & Herzegovina",
    "emoji": "🇧🇦"
  },
  "Barbados": {
    "code": "BB",
    "unicode": "U+1F1E7 U+1F1E7",
    "name": "Barbados",
    "emoji": "🇧🇧"
  },
  "Bangladesh": {
    "code": "BD",
    "unicode": "U+1F1E7 U+1F1E9",
    "name": "Bangladesh",
    "emoji": "🇧🇩"
  },
  "Belgium": {
    "code": "BE",
    "unicode": "U+1F1E7 U+1F1EA",
    "name": "Belgium",
    "emoji": "🇧🇪"
  },
  "Burkina Faso": {
    "code": "BF",
    "unicode": "U+1F1E7 U+1F1EB",
    "name": "Burkina Faso",
    "emoji": "🇧🇫"
  },
  "Bulgaria": {
    "code": "BG",
    "unicode": "U+1F1E7 U+1F1EC",
    "name": "Bulgaria",
    "emoji": "🇧🇬"
  },
  "Bahrain": {
    "code": "BH",
    "unicode": "U+1F1E7 U+1F1ED",
    "name": "Bahrain",
    "emoji": "🇧🇭"
  },
  "Burundi": {
    "code": "BI",
    "unicode": "U+1F1E7 U+1F1EE",
    "name": "Burundi",
    "emoji": "🇧🇮"
  },
  "Benin": {
    "code": "BJ",
    "unicode": "U+1F1E7 U+1F1EF",
    "name": "Benin",
    "emoji": "🇧🇯"
  },
  "St. Barthélemy": {
    "code": "BL",
    "unicode": "U+1F1E7 U+1F1F1",
    "name": "St. Barthélemy",
    "emoji": "🇧🇱"
  },
  "Bermuda": {
    "code": "BM",
    "unicode": "U+1F1E7 U+1F1F2",
    "name": "Bermuda",
    "emoji": "🇧🇲"
  },
  "Brunei": {
    "code": "BN",
    "unicode": "U+1F1E7 U+1F1F3",
    "name": "Brunei",
    "emoji": "🇧🇳"
  },
  "Bolivia": {
    "code": "BO",
    "unicode": "U+1F1E7 U+1F1F4",
    "name": "Bolivia",
    "emoji": "🇧🇴"
  },
  "Caribbean Netherlands": {
    "code": "BQ",
    "unicode": "U+1F1E7 U+1F1F6",
    "name": "Caribbean Netherlands",
    "emoji": "🇧🇶"
  },
  "Brazil": {
    "code": "BR",
    "unicode": "U+1F1E7 U+1F1F7",
    "name": "Brazil",
    "emoji": "🇧🇷"
  },
  "Bahamas": {
    "code": "BS",
    "unicode": "U+1F1E7 U+1F1F8",
    "name": "Bahamas",
    "emoji": "🇧🇸"
  },
  "Bhutan": {
    "code": "BT",
    "unicode": "U+1F1E7 U+1F1F9",
    "name": "Bhutan",
    "emoji": "🇧🇹"
  },
  "Bouvet Island": {
    "code": "BV",
    "unicode": "U+1F1E7 U+1F1FB",
    "name": "Bouvet Island",
    "emoji": "🇧🇻"
  },
  "Botswana": {
    "code": "BW",
    "unicode": "U+1F1E7 U+1F1FC",
    "name": "Botswana",
    "emoji": "🇧🇼"
  },
  "Belarus": {
    "code": "BY",
    "unicode": "U+1F1E7 U+1F1FE",
    "name": "Belarus",
    "emoji": "🇧🇾"
  },
  "Belize": {
    "code": "BZ",
    "unicode": "U+1F1E7 U+1F1FF",
    "name": "Belize",
    "emoji": "🇧🇿"
  },
  "Canada": {
    "code": "CA",
    "unicode": "U+1F1E8 U+1F1E6",
    "name": "Canada",
    "emoji": "🇨🇦"
  },
  "Cocos (Keeling) Islands": {
    "code": "CC",
    "unicode": "U+1F1E8 U+1F1E8",
    "name": "Cocos (Keeling) Islands",
    "emoji": "🇨🇨"
  },
  "Congo - Kinshasa": {
    "code": "CD",
    "unicode": "U+1F1E8 U+1F1E9",
    "name": "Congo - Kinshasa",
    "emoji": "🇨🇩"
  },
  "Central African Republic": {
    "code": "CF",
    "unicode": "U+1F1E8 U+1F1EB",
    "name": "Central African Republic",
    "emoji": "🇨🇫"
  },
  "Congo - Brazzaville": {
    "code": "CG",
    "unicode": "U+1F1E8 U+1F1EC",
    "name": "Congo - Brazzaville",
    "emoji": "🇨🇬"
  },
  "Switzerland": {
    "code": "CH",
    "unicode": "U+1F1E8 U+1F1ED",
    "name": "Switzerland",
    "emoji": "🇨🇭"
  },
  "Côte d’Ivoire": {
    "code": "CI",
    "unicode": "U+1F1E8 U+1F1EE",
    "name": "Côte d’Ivoire",
    "emoji": "🇨🇮"
  },
  "Cook Islands": {
    "code": "CK",
    "unicode": "U+1F1E8 U+1F1F0",
    "name": "Cook Islands",
    "emoji": "🇨🇰"
  },
  "Chile": {
    "code": "CL",
    "unicode": "U+1F1E8 U+1F1F1",
    "name": "Chile",
    "emoji": "🇨🇱"
  },
  "Cameroon": {
    "code": "CM",
    "unicode": "U+1F1E8 U+1F1F2",
    "name": "Cameroon",
    "emoji": "🇨🇲"
  },
  "China": {
    "code": "CN",
    "unicode": "U+1F1E8 U+1F1F3",
    "name": "China",
    "emoji": "🇨🇳"
  },
  "Colombia": {
    "code": "CO",
    "unicode": "U+1F1E8 U+1F1F4",
    "name": "Colombia",
    "emoji": "🇨🇴"
  },
  "Clipperton Island": {
    "code": "CP",
    "unicode": "U+1F1E8 U+1F1F5",
    "name": "Clipperton Island",
    "emoji": "🇨🇵"
  },
  "Costa Rica": {
    "code": "CR",
    "unicode": "U+1F1E8 U+1F1F7",
    "name": "Costa Rica",
    "emoji": "🇨🇷"
  },
  "Cuba": {
    "code": "CU",
    "unicode": "U+1F1E8 U+1F1FA",
    "name": "Cuba",
    "emoji": "🇨🇺"
  },
  "Cape Verde": {
    "code": "CV",
    "unicode": "U+1F1E8 U+1F1FB",
    "name": "Cape Verde",
    "emoji": "🇨🇻"
  },
  "Curaçao": {
    "code": "CW",
    "unicode": "U+1F1E8 U+1F1FC",
    "name": "Curaçao",
    "emoji": "🇨🇼"
  },
  "Christmas Island": {
    "code": "CX",
    "unicode": "U+1F1E8 U+1F1FD",
    "name": "Christmas Island",
    "emoji": "🇨🇽"
  },
  "Cyprus": {
    "code": "CY",
    "unicode": "U+1F1E8 U+1F1FE",
    "name": "Cyprus",
    "emoji": "🇨🇾"
  },
  "Czech Republic": {
    "code": "CZ",
    "unicode": "U+1F1E8 U+1F1FF",
    "name": "Czech Republic",
    "emoji": "🇨🇿"
  },
  "Germany": {
    "code": "DE",
    "unicode": "U+1F1E9 U+1F1EA",
    "name": "Germany",
    "emoji": "🇩🇪"
  },
  "Diego Garcia": {
    "code": "DG",
    "unicode": "U+1F1E9 U+1F1EC",
    "name": "Diego Garcia",
    "emoji": "🇩🇬"
  },
  "Djibouti": {
    "code": "DJ",
    "unicode": "U+1F1E9 U+1F1EF",
    "name": "Djibouti",
    "emoji": "🇩🇯"
  },
  "Denmark": {
    "code": "DK",
    "unicode": "U+1F1E9 U+1F1F0",
    "name": "Denmark",
    "emoji": "🇩🇰"
  },
  "Dominica": {
    "code": "DM",
    "unicode": "U+1F1E9 U+1F1F2",
    "name": "Dominica",
    "emoji": "🇩🇲"
  },
  "Dominican Republic": {
    "code": "DO",
    "unicode": "U+1F1E9 U+1F1F4",
    "name": "Dominican Republic",
    "emoji": "🇩🇴"
  },
  "Algeria": {
    "code": "DZ",
    "unicode": "U+1F1E9 U+1F1FF",
    "name": "Algeria",
    "emoji": "🇩🇿"
  },
  "Ceuta & Melilla": {
    "code": "EA",
    "unicode": "U+1F1EA U+1F1E6",
    "name": "Ceuta & Melilla",
    "emoji": "🇪🇦"
  },
  "Ecuador": {
    "code": "EC",
    "unicode": "U+1F1EA U+1F1E8",
    "name": "Ecuador",
    "emoji": "🇪🇨"
  },
  "Estonia": {
    "code": "EE",
    "unicode": "U+1F1EA U+1F1EA",
    "name": "Estonia",
    "emoji": "🇪🇪"
  },
  "Egypt": {
    "code": "EG",
    "unicode": "U+1F1EA U+1F1EC",
    "name": "Egypt",
    "emoji": "🇪🇬"
  },
  "Western Sahara": {
    "code": "EH",
    "unicode": "U+1F1EA U+1F1ED",
    "name": "Western Sahara",
    "emoji": "🇪🇭"
  },
  "Eritrea": {
    "code": "ER",
    "unicode": "U+1F1EA U+1F1F7",
    "name": "Eritrea",
    "emoji": "🇪🇷"
  },
  "Spain": {
    "code": "ES",
    "unicode": "U+1F1EA U+1F1F8",
    "name": "Spain",
    "emoji": "🇪🇸"
  },
  "Ethiopia": {
    "code": "ET",
    "unicode": "U+1F1EA U+1F1F9",
    "name": "Ethiopia",
    "emoji": "🇪🇹"
  },
  "European Union": {
    "code": "EU",
    "unicode": "U+1F1EA U+1F1FA",
    "name": "European Union",
    "emoji": "🇪🇺"
  },
  "Finland": {
    "code": "FI",
    "unicode": "U+1F1EB U+1F1EE",
    "name": "Finland",
    "emoji": "🇫🇮"
  },
  "Fiji": {
    "code": "FJ",
    "unicode": "U+1F1EB U+1F1EF",
    "name": "Fiji",
    "emoji": "🇫🇯"
  },
  "Falkland Islands": {
    "code": "FK",
    "unicode": "U+1F1EB U+1F1F0",
    "name": "Falkland Islands",
    "emoji": "🇫🇰"
  },
  "Micronesia": {
    "code": "FM",
    "unicode": "U+1F1EB U+1F1F2",
    "name": "Micronesia",
    "emoji": "🇫🇲"
  },
  "Faroe Islands": {
    "code": "FO",
    "unicode": "U+1F1EB U+1F1F4",
    "name": "Faroe Islands",
    "emoji": "🇫🇴"
  },
  "France": {
    "code": "FR",
    "unicode": "U+1F1EB U+1F1F7",
    "name": "France",
    "emoji": "🇫🇷"
  },
  "Gabon": {
    "code": "GA",
    "unicode": "U+1F1EC U+1F1E6",
    "name": "Gabon",
    "emoji": "🇬🇦"
  },
  "England": {
    "code": "GB",
    "unicode": "U+1F1EC U+1F1E7",
    "name": "England",
    "emoji": "🇬🇧"
  },
  "Wales": {
    "code": "WL",
    "unicode": "U+1F1EC U+1F1E7",
    "name": "Wales",
    "emoji": "🏴󠁧󠁢󠁷󠁬󠁳󠁿"
  },
  "Scotland": {
    "code": "SC",
    "unicode": "U+1F1EC U+1F1E7",
    "name": "Scotland",
    "emoji": "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
  },
  "Grenada": {
    "code": "GD",
    "unicode": "U+1F1EC U+1F1E9",
    "name": "Grenada",
    "emoji": "🇬🇩"
  },
  "Georgia": {
    "code": "GE",
    "unicode": "U+1F1EC U+1F1EA",
    "name": "Georgia",
    "emoji": "🇬🇪"
  },
  "French Guiana": {
    "code": "GF",
    "unicode": "U+1F1EC U+1F1EB",
    "name": "French Guiana",
    "emoji": "🇬🇫"
  },
  "Guernsey": {
    "code": "GG",
    "unicode": "U+1F1EC U+1F1EC",
    "name": "Guernsey",
    "emoji": "🇬🇬"
  },
  "Ghana": {
    "code": "GH",
    "unicode": "U+1F1EC U+1F1ED",
    "name": "Ghana",
    "emoji": "🇬🇭"
  },
  "Gibraltar": {
    "code": "GI",
    "unicode": "U+1F1EC U+1F1EE",
    "name": "Gibraltar",
    "emoji": "🇬🇮"
  },
  "Greenland": {
    "code": "GL",
    "unicode": "U+1F1EC U+1F1F1",
    "name": "Greenland",
    "emoji": "🇬🇱"
  },
  "Gambia": {
    "code": "GM",
    "unicode": "U+1F1EC U+1F1F2",
    "name": "Gambia",
    "emoji": "🇬🇲"
  },
  "Guinea": {
    "code": "GN",
    "unicode": "U+1F1EC U+1F1F3",
    "name": "Guinea",
    "emoji": "🇬🇳"
  },
  "Guadeloupe": {
    "code": "GP",
    "unicode": "U+1F1EC U+1F1F5",
    "name": "Guadeloupe",
    "emoji": "🇬🇵"
  },
  "Equatorial Guinea": {
    "code": "GQ",
    "unicode": "U+1F1EC U+1F1F6",
    "name": "Equatorial Guinea",
    "emoji": "🇬🇶"
  },
  "Greece": {
    "code": "GR",
    "unicode": "U+1F1EC U+1F1F7",
    "name": "Greece",
    "emoji": "🇬🇷"
  },
  "South Georgia & South Sandwich Islands": {
    "code": "GS",
    "unicode": "U+1F1EC U+1F1F8",
    "name": "South Georgia & South Sandwich Islands",
    "emoji": "🇬🇸"
  },
  "Guatemala": {
    "code": "GT",
    "unicode": "U+1F1EC U+1F1F9",
    "name": "Guatemala",
    "emoji": "🇬🇹"
  },
  "Guam": {
    "code": "GU",
    "unicode": "U+1F1EC U+1F1FA",
    "name": "Guam",
    "emoji": "🇬🇺"
  },
  "Guinea-Bissau": {
    "code": "GW",
    "unicode": "U+1F1EC U+1F1FC",
    "name": "Guinea-Bissau",
    "emoji": "🇬🇼"
  },
  "Guyana": {
    "code": "GY",
    "unicode": "U+1F1EC U+1F1FE",
    "name": "Guyana",
    "emoji": "🇬🇾"
  },
  "Hong Kong SAR China": {
    "code": "HK",
    "unicode": "U+1F1ED U+1F1F0",
    "name": "Hong Kong SAR China",
    "emoji": "🇭🇰"
  },
  "Heard & McDonald Islands": {
    "code": "HM",
    "unicode": "U+1F1ED U+1F1F2",
    "name": "Heard & McDonald Islands",
    "emoji": "🇭🇲"
  },
  "Honduras": {
    "code": "HN",
    "unicode": "U+1F1ED U+1F1F3",
    "name": "Honduras",
    "emoji": "🇭🇳"
  },
  "Croatia": {
    "code": "HR",
    "unicode": "U+1F1ED U+1F1F7",
    "name": "Croatia",
    "emoji": "🇭🇷"
  },
  "Haiti": {
    "code": "HT",
    "unicode": "U+1F1ED U+1F1F9",
    "name": "Haiti",
    "emoji": "🇭🇹"
  },
  "Hungary": {
    "code": "HU",
    "unicode": "U+1F1ED U+1F1FA",
    "name": "Hungary",
    "emoji": "🇭🇺"
  },
  "Canary Islands": {
    "code": "IC",
    "unicode": "U+1F1EE U+1F1E8",
    "name": "Canary Islands",
    "emoji": "🇮🇨"
  },
  "Indonesia": {
    "code": "ID",
    "unicode": "U+1F1EE U+1F1E9",
    "name": "Indonesia",
    "emoji": "🇮🇩"
  },
  "Ireland": {
    "code": "IE",
    "unicode": "U+1F1EE U+1F1EA",
    "name": "Ireland",
    "emoji": "🇮🇪"
  },
  "Israel": {
    "code": "IL",
    "unicode": "U+1F1EE U+1F1F1",
    "name": "Israel",
    "emoji": "🇮🇱"
  },
  "Isle of Man": {
    "code": "IM",
    "unicode": "U+1F1EE U+1F1F2",
    "name": "Isle of Man",
    "emoji": "🇮🇲"
  },
  "India": {
    "code": "IN",
    "unicode": "U+1F1EE U+1F1F3",
    "name": "India",
    "emoji": "🇮🇳"
  },
  "British Indian Ocean Territory": {
    "code": "IO",
    "unicode": "U+1F1EE U+1F1F4",
    "name": "British Indian Ocean Territory",
    "emoji": "🇮🇴"
  },
  "Iraq": {
    "code": "IQ",
    "unicode": "U+1F1EE U+1F1F6",
    "name": "Iraq",
    "emoji": "🇮🇶"
  },
  "Iran": {
    "code": "IR",
    "unicode": "U+1F1EE U+1F1F7",
    "name": "Iran",
    "emoji": "🇮🇷"
  },
  "Iceland": {
    "code": "IS",
    "unicode": "U+1F1EE U+1F1F8",
    "name": "Iceland",
    "emoji": "🇮🇸"
  },
  "Italy": {
    "code": "IT",
    "unicode": "U+1F1EE U+1F1F9",
    "name": "Italy",
    "emoji": "🇮🇹"
  },
  "Jersey": {
    "code": "JE",
    "unicode": "U+1F1EF U+1F1EA",
    "name": "Jersey",
    "emoji": "🇯🇪"
  },
  "Jamaica": {
    "code": "JM",
    "unicode": "U+1F1EF U+1F1F2",
    "name": "Jamaica",
    "emoji": "🇯🇲"
  },
  "Jordan": {
    "code": "JO",
    "unicode": "U+1F1EF U+1F1F4",
    "name": "Jordan",
    "emoji": "🇯🇴"
  },
  "Japan": {
    "code": "JP",
    "unicode": "U+1F1EF U+1F1F5",
    "name": "Japan",
    "emoji": "🇯🇵"
  },
  "Kenya": {
    "code": "KE",
    "unicode": "U+1F1F0 U+1F1EA",
    "name": "Kenya",
    "emoji": "🇰🇪"
  },
  "Kyrgyzstan": {
    "code": "KG",
    "unicode": "U+1F1F0 U+1F1EC",
    "name": "Kyrgyzstan",
    "emoji": "🇰🇬"
  },
  "Cambodia": {
    "code": "KH",
    "unicode": "U+1F1F0 U+1F1ED",
    "name": "Cambodia",
    "emoji": "🇰🇭"
  },
  "Kiribati": {
    "code": "KI",
    "unicode": "U+1F1F0 U+1F1EE",
    "name": "Kiribati",
    "emoji": "🇰🇮"
  },
  "Comoros": {
    "code": "KM",
    "unicode": "U+1F1F0 U+1F1F2",
    "name": "Comoros",
    "emoji": "🇰🇲"
  },
  "St. Kitts & Nevis": {
    "code": "KN",
    "unicode": "U+1F1F0 U+1F1F3",
    "name": "St. Kitts & Nevis",
    "emoji": "🇰🇳"
  },
  "North Korea": {
    "code": "KP",
    "unicode": "U+1F1F0 U+1F1F5",
    "name": "North Korea",
    "emoji": "🇰🇵"
  },
  "South Korea": {
    "code": "KR",
    "unicode": "U+1F1F0 U+1F1F7",
    "name": "South Korea",
    "emoji": "🇰🇷"
  },
  "Kuwait": {
    "code": "KW",
    "unicode": "U+1F1F0 U+1F1FC",
    "name": "Kuwait",
    "emoji": "🇰🇼"
  },
  "Cayman Islands": {
    "code": "KY",
    "unicode": "U+1F1F0 U+1F1FE",
    "name": "Cayman Islands",
    "emoji": "🇰🇾"
  },
  "Kazakhstan": {
    "code": "KZ",
    "unicode": "U+1F1F0 U+1F1FF",
    "name": "Kazakhstan",
    "emoji": "🇰🇿"
  },
  "Laos": {
    "code": "LA",
    "unicode": "U+1F1F1 U+1F1E6",
    "name": "Laos",
    "emoji": "🇱🇦"
  },
  "Lebanon": {
    "code": "LB",
    "unicode": "U+1F1F1 U+1F1E7",
    "name": "Lebanon",
    "emoji": "🇱🇧"
  },
  "St. Lucia": {
    "code": "LC",
    "unicode": "U+1F1F1 U+1F1E8",
    "name": "St. Lucia",
    "emoji": "🇱🇨"
  },
  "Liechtenstein": {
    "code": "LI",
    "unicode": "U+1F1F1 U+1F1EE",
    "name": "Liechtenstein",
    "emoji": "🇱🇮"
  },
  "Sri Lanka": {
    "code": "LK",
    "unicode": "U+1F1F1 U+1F1F0",
    "name": "Sri Lanka",
    "emoji": "🇱🇰"
  },
  "Liberia": {
    "code": "LR",
    "unicode": "U+1F1F1 U+1F1F7",
    "name": "Liberia",
    "emoji": "🇱🇷"
  },
  "Lesotho": {
    "code": "LS",
    "unicode": "U+1F1F1 U+1F1F8",
    "name": "Lesotho",
    "emoji": "🇱🇸"
  },
  "Lithuania": {
    "code": "LT",
    "unicode": "U+1F1F1 U+1F1F9",
    "name": "Lithuania",
    "emoji": "🇱🇹"
  },
  "Luxembourg": {
    "code": "LU",
    "unicode": "U+1F1F1 U+1F1FA",
    "name": "Luxembourg",
    "emoji": "🇱🇺"
  },
  "Latvia": {
    "code": "LV",
    "unicode": "U+1F1F1 U+1F1FB",
    "name": "Latvia",
    "emoji": "🇱🇻"
  },
  "Libya": {
    "code": "LY",
    "unicode": "U+1F1F1 U+1F1FE",
    "name": "Libya",
    "emoji": "🇱🇾"
  },
  "Morocco": {
    "code": "MA",
    "unicode": "U+1F1F2 U+1F1E6",
    "name": "Morocco",
    "emoji": "🇲🇦"
  },
  "Monaco": {
    "code": "MC",
    "unicode": "U+1F1F2 U+1F1E8",
    "name": "Monaco",
    "emoji": "🇲🇨"
  },
  "Moldova": {
    "code": "MD",
    "unicode": "U+1F1F2 U+1F1E9",
    "name": "Moldova",
    "emoji": "🇲🇩"
  },
  "Montenegro": {
    "code": "ME",
    "unicode": "U+1F1F2 U+1F1EA",
    "name": "Montenegro",
    "emoji": "🇲🇪"
  },
  "St. Martin": {
    "code": "MF",
    "unicode": "U+1F1F2 U+1F1EB",
    "name": "St. Martin",
    "emoji": "🇲🇫"
  },
  "Madagascar": {
    "code": "MG",
    "unicode": "U+1F1F2 U+1F1EC",
    "name": "Madagascar",
    "emoji": "🇲🇬"
  },
  "Marshall Islands": {
    "code": "MH",
    "unicode": "U+1F1F2 U+1F1ED",
    "name": "Marshall Islands",
    "emoji": "🇲🇭"
  },
  "North Macedonia": {
    "code": "MK",
    "unicode": "U+1F1F2 U+1F1F0",
    "name": "North Macedonia",
    "emoji": "🇲🇰"
  },
  "Mali": {
    "code": "ML",
    "unicode": "U+1F1F2 U+1F1F1",
    "name": "Mali",
    "emoji": "🇲🇱"
  },
  "Myanmar (Burma)": {
    "code": "MM",
    "unicode": "U+1F1F2 U+1F1F2",
    "name": "Myanmar (Burma)",
    "emoji": "🇲🇲"
  },
  "Mongolia": {
    "code": "MN",
    "unicode": "U+1F1F2 U+1F1F3",
    "name": "Mongolia",
    "emoji": "🇲🇳"
  },
  "Macau SAR China": {
    "code": "MO",
    "unicode": "U+1F1F2 U+1F1F4",
    "name": "Macau SAR China",
    "emoji": "🇲🇴"
  },
  "Northern Mariana Islands": {
    "code": "MP",
    "unicode": "U+1F1F2 U+1F1F5",
    "name": "Northern Mariana Islands",
    "emoji": "🇲🇵"
  },
  "Martinique": {
    "code": "MQ",
    "unicode": "U+1F1F2 U+1F1F6",
    "name": "Martinique",
    "emoji": "🇲🇶"
  },
  "Mauritania": {
    "code": "MR",
    "unicode": "U+1F1F2 U+1F1F7",
    "name": "Mauritania",
    "emoji": "🇲🇷"
  },
  "Montserrat": {
    "code": "MS",
    "unicode": "U+1F1F2 U+1F1F8",
    "name": "Montserrat",
    "emoji": "🇲🇸"
  },
  "Malta": {
    "code": "MT",
    "unicode": "U+1F1F2 U+1F1F9",
    "name": "Malta",
    "emoji": "🇲🇹"
  },
  "Mauritius": {
    "code": "MU",
    "unicode": "U+1F1F2 U+1F1FA",
    "name": "Mauritius",
    "emoji": "🇲🇺"
  },
  "Maldives": {
    "code": "MV",
    "unicode": "U+1F1F2 U+1F1FB",
    "name": "Maldives",
    "emoji": "🇲🇻"
  },
  "Malawi": {
    "code": "MW",
    "unicode": "U+1F1F2 U+1F1FC",
    "name": "Malawi",
    "emoji": "🇲🇼"
  },
  "Mexico": {
    "code": "MX",
    "unicode": "U+1F1F2 U+1F1FD",
    "name": "Mexico",
    "emoji": "🇲🇽"
  },
  "Malaysia": {
    "code": "MY",
    "unicode": "U+1F1F2 U+1F1FE",
    "name": "Malaysia",
    "emoji": "🇲🇾"
  },
  "Mozambique": {
    "code": "MZ",
    "unicode": "U+1F1F2 U+1F1FF",
    "name": "Mozambique",
    "emoji": "🇲🇿"
  },
  "Namibia": {
    "code": "NA",
    "unicode": "U+1F1F3 U+1F1E6",
    "name": "Namibia",
    "emoji": "🇳🇦"
  },
  "New Caledonia": {
    "code": "NC",
    "unicode": "U+1F1F3 U+1F1E8",
    "name": "New Caledonia",
    "emoji": "🇳🇨"
  },
  "Niger": {
    "code": "NE",
    "unicode": "U+1F1F3 U+1F1EA",
    "name": "Niger",
    "emoji": "🇳🇪"
  },
  "Norfolk Island": {
    "code": "NF",
    "unicode": "U+1F1F3 U+1F1EB",
    "name": "Norfolk Island",
    "emoji": "🇳🇫"
  },
  "Nigeria": {
    "code": "NG",
    "unicode": "U+1F1F3 U+1F1EC",
    "name": "Nigeria",
    "emoji": "🇳🇬"
  },
  "Nicaragua": {
    "code": "NI",
    "unicode": "U+1F1F3 U+1F1EE",
    "name": "Nicaragua",
    "emoji": "🇳🇮"
  },
  "Netherlands": {
    "code": "NL",
    "unicode": "U+1F1F3 U+1F1F1",
    "name": "Netherlands",
    "emoji": "🇳🇱"
  },
  "Norway": {
    "code": "NO",
    "unicode": "U+1F1F3 U+1F1F4",
    "name": "Norway",
    "emoji": "🇳🇴"
  },
  "Nepal": {
    "code": "NP",
    "unicode": "U+1F1F3 U+1F1F5",
    "name": "Nepal",
    "emoji": "🇳🇵"
  },
  "Nauru": {
    "code": "NR",
    "unicode": "U+1F1F3 U+1F1F7",
    "name": "Nauru",
    "emoji": "🇳🇷"
  },
  "Niue": {
    "code": "NU",
    "unicode": "U+1F1F3 U+1F1FA",
    "name": "Niue",
    "emoji": "🇳🇺"
  },
  "New Zealand": {
    "code": "NZ",
    "unicode": "U+1F1F3 U+1F1FF",
    "name": "New Zealand",
    "emoji": "🇳🇿"
  },
  "Oman": {
    "code": "OM",
    "unicode": "U+1F1F4 U+1F1F2",
    "name": "Oman",
    "emoji": "🇴🇲"
  },
  "Panama": {
    "code": "PA",
    "unicode": "U+1F1F5 U+1F1E6",
    "name": "Panama",
    "emoji": "🇵🇦"
  },
  "Peru": {
    "code": "PE",
    "unicode": "U+1F1F5 U+1F1EA",
    "name": "Peru",
    "emoji": "🇵🇪"
  },
  "French Polynesia": {
    "code": "PF",
    "unicode": "U+1F1F5 U+1F1EB",
    "name": "French Polynesia",
    "emoji": "🇵🇫"
  },
  "Papua New Guinea": {
    "code": "PG",
    "unicode": "U+1F1F5 U+1F1EC",
    "name": "Papua New Guinea",
    "emoji": "🇵🇬"
  },
  "Philippines": {
    "code": "PH",
    "unicode": "U+1F1F5 U+1F1ED",
    "name": "Philippines",
    "emoji": "🇵🇭"
  },
  "Pakistan": {
    "code": "PK",
    "unicode": "U+1F1F5 U+1F1F0",
    "name": "Pakistan",
    "emoji": "🇵🇰"
  },
  "Poland": {
    "code": "PL",
    "unicode": "U+1F1F5 U+1F1F1",
    "name": "Poland",
    "emoji": "🇵🇱"
  },
  "St. Pierre & Miquelon": {
    "code": "PM",
    "unicode": "U+1F1F5 U+1F1F2",
    "name": "St. Pierre & Miquelon",
    "emoji": "🇵🇲"
  },
  "Pitcairn Islands": {
    "code": "PN",
    "unicode": "U+1F1F5 U+1F1F3",
    "name": "Pitcairn Islands",
    "emoji": "🇵🇳"
  },
  "Puerto Rico": {
    "code": "PR",
    "unicode": "U+1F1F5 U+1F1F7",
    "name": "Puerto Rico",
    "emoji": "🇵🇷"
  },
  "Palestinian Territories": {
    "code": "PS",
    "unicode": "U+1F1F5 U+1F1F8",
    "name": "Palestinian Territories",
    "emoji": "🇵🇸"
  },
  "Portugal": {
    "code": "PT",
    "unicode": "U+1F1F5 U+1F1F9",
    "name": "Portugal",
    "emoji": "🇵🇹"
  },
  "Palau": {
    "code": "PW",
    "unicode": "U+1F1F5 U+1F1FC",
    "name": "Palau",
    "emoji": "🇵🇼"
  },
  "Paraguay": {
    "code": "PY",
    "unicode": "U+1F1F5 U+1F1FE",
    "name": "Paraguay",
    "emoji": "🇵🇾"
  },
  "Qatar": {
    "code": "QA",
    "unicode": "U+1F1F6 U+1F1E6",
    "name": "Qatar",
    "emoji": "🇶🇦"
  },
  "Réunion": {
    "code": "RE",
    "unicode": "U+1F1F7 U+1F1EA",
    "name": "Réunion",
    "emoji": "🇷🇪"
  },
  "Romania": {
    "code": "RO",
    "unicode": "U+1F1F7 U+1F1F4",
    "name": "Romania",
    "emoji": "🇷🇴"
  },
  "Serbia": {
    "code": "RS",
    "unicode": "U+1F1F7 U+1F1F8",
    "name": "Serbia",
    "emoji": "🇷🇸"
  },
  "Russia": {
    "code": "RU",
    "unicode": "U+1F1F7 U+1F1FA",
    "name": "Russia",
    "emoji": "🇷🇺"
  },
  "Rwanda": {
    "code": "RW",
    "unicode": "U+1F1F7 U+1F1FC",
    "name": "Rwanda",
    "emoji": "🇷🇼"
  },
  "Saudi Arabia": {
    "code": "SA",
    "unicode": "U+1F1F8 U+1F1E6",
    "name": "Saudi Arabia",
    "emoji": "🇸🇦"
  },
  "Solomon Islands": {
    "code": "SB",
    "unicode": "U+1F1F8 U+1F1E7",
    "name": "Solomon Islands",
    "emoji": "🇸🇧"
  },
  "Seychelles": {
    "code": "SC",
    "unicode": "U+1F1F8 U+1F1E8",
    "name": "Seychelles",
    "emoji": "🇸🇨"
  },
  "Sudan": {
    "code": "SD",
    "unicode": "U+1F1F8 U+1F1E9",
    "name": "Sudan",
    "emoji": "🇸🇩"
  },
  "Sweden": {
    "code": "SE",
    "unicode": "U+1F1F8 U+1F1EA",
    "name": "Sweden",
    "emoji": "🇸🇪"
  },
  "Singapore": {
    "code": "SG",
    "unicode": "U+1F1F8 U+1F1EC",
    "name": "Singapore",
    "emoji": "🇸🇬"
  },
  "St. Helena": {
    "code": "SH",
    "unicode": "U+1F1F8 U+1F1ED",
    "name": "St. Helena",
    "emoji": "🇸🇭"
  },
  "Slovenia": {
    "code": "SI",
    "unicode": "U+1F1F8 U+1F1EE",
    "name": "Slovenia",
    "emoji": "🇸🇮"
  },
  "Svalbard & Jan Mayen": {
    "code": "SJ",
    "unicode": "U+1F1F8 U+1F1EF",
    "name": "Svalbard & Jan Mayen",
    "emoji": "🇸🇯"
  },
  "Slovakia": {
    "code": "SK",
    "unicode": "U+1F1F8 U+1F1F0",
    "name": "Slovakia",
    "emoji": "🇸🇰"
  },
  "Sierra Leone": {
    "code": "SL",
    "unicode": "U+1F1F8 U+1F1F1",
    "name": "Sierra Leone",
    "emoji": "🇸🇱"
  },
  "San Marino": {
    "code": "SM",
    "unicode": "U+1F1F8 U+1F1F2",
    "name": "San Marino",
    "emoji": "🇸🇲"
  },
  "Senegal": {
    "code": "SN",
    "unicode": "U+1F1F8 U+1F1F3",
    "name": "Senegal",
    "emoji": "🇸🇳"
  },
  "Somalia": {
    "code": "SO",
    "unicode": "U+1F1F8 U+1F1F4",
    "name": "Somalia",
    "emoji": "🇸🇴"
  },
  "Suriname": {
    "code": "SR",
    "unicode": "U+1F1F8 U+1F1F7",
    "name": "Suriname",
    "emoji": "🇸🇷"
  },
  "South Sudan": {
    "code": "SS",
    "unicode": "U+1F1F8 U+1F1F8",
    "name": "South Sudan",
    "emoji": "🇸🇸"
  },
  "São Tomé & Príncipe": {
    "code": "ST",
    "unicode": "U+1F1F8 U+1F1F9",
    "name": "São Tomé & Príncipe",
    "emoji": "🇸🇹"
  },
  "El Salvador": {
    "code": "SV",
    "unicode": "U+1F1F8 U+1F1FB",
    "name": "El Salvador",
    "emoji": "🇸🇻"
  },
  "Sint Maarten": {
    "code": "SX",
    "unicode": "U+1F1F8 U+1F1FD",
    "name": "Sint Maarten",
    "emoji": "🇸🇽"
  },
  "Syria": {
    "code": "SY",
    "unicode": "U+1F1F8 U+1F1FE",
    "name": "Syria",
    "emoji": "🇸🇾"
  },
  "Swaziland": {
    "code": "SZ",
    "unicode": "U+1F1F8 U+1F1FF",
    "name": "Swaziland",
    "emoji": "🇸🇿"
  },
  "Tristan da Cunha": {
    "code": "TA",
    "unicode": "U+1F1F9 U+1F1E6",
    "name": "Tristan da Cunha",
    "emoji": "🇹🇦"
  },
  "Turks & Caicos Islands": {
    "code": "TC",
    "unicode": "U+1F1F9 U+1F1E8",
    "name": "Turks & Caicos Islands",
    "emoji": "🇹🇨"
  },
  "Chad": {
    "code": "TD",
    "unicode": "U+1F1F9 U+1F1E9",
    "name": "Chad",
    "emoji": "🇹🇩"
  },
  "French Southern Territories": {
    "code": "TF",
    "unicode": "U+1F1F9 U+1F1EB",
    "name": "French Southern Territories",
    "emoji": "🇹🇫"
  },
  "Togo": {
    "code": "TG",
    "unicode": "U+1F1F9 U+1F1EC",
    "name": "Togo",
    "emoji": "🇹🇬"
  },
  "Thailand": {
    "code": "TH",
    "unicode": "U+1F1F9 U+1F1ED",
    "name": "Thailand",
    "emoji": "🇹🇭"
  },
  "Tajikistan": {
    "code": "TJ",
    "unicode": "U+1F1F9 U+1F1EF",
    "name": "Tajikistan",
    "emoji": "🇹🇯"
  },
  "Tokelau": {
    "code": "TK",
    "unicode": "U+1F1F9 U+1F1F0",
    "name": "Tokelau",
    "emoji": "🇹🇰"
  },
  "Timor-Leste": {
    "code": "TL",
    "unicode": "U+1F1F9 U+1F1F1",
    "name": "Timor-Leste",
    "emoji": "🇹🇱"
  },
  "Turkmenistan": {
    "code": "TM",
    "unicode": "U+1F1F9 U+1F1F2",
    "name": "Turkmenistan",
    "emoji": "🇹🇲"
  },
  "Tunisia": {
    "code": "TN",
    "unicode": "U+1F1F9 U+1F1F3",
    "name": "Tunisia",
    "emoji": "🇹🇳"
  },
  "Tonga": {
    "code": "TO",
    "unicode": "U+1F1F9 U+1F1F4",
    "name": "Tonga",
    "emoji": "🇹🇴"
  },
  "Turkey": {
    "code": "TR",
    "unicode": "U+1F1F9 U+1F1F7",
    "name": "Turkey",
    "emoji": "🇹🇷"
  },
  "Trinidad & Tobago": {
    "code": "TT",
    "unicode": "U+1F1F9 U+1F1F9",
    "name": "Trinidad & Tobago",
    "emoji": "🇹🇹"
  },
  "Tuvalu": {
    "code": "TV",
    "unicode": "U+1F1F9 U+1F1FB",
    "name": "Tuvalu",
    "emoji": "🇹🇻"
  },
  "Taiwan": {
    "code": "TW",
    "unicode": "U+1F1F9 U+1F1FC",
    "name": "Taiwan",
    "emoji": "🇹🇼"
  },
  "Tanzania": {
    "code": "TZ",
    "unicode": "U+1F1F9 U+1F1FF",
    "name": "Tanzania",
    "emoji": "🇹🇿"
  },
  "Ukraine": {
    "code": "UA",
    "unicode": "U+1F1FA U+1F1E6",
    "name": "Ukraine",
    "emoji": "🇺🇦"
  },
  "Uganda": {
    "code": "UG",
    "unicode": "U+1F1FA U+1F1EC",
    "name": "Uganda",
    "emoji": "🇺🇬"
  },
  "U.S. Outlying Islands": {
    "code": "UM",
    "unicode": "U+1F1FA U+1F1F2",
    "name": "U.S. Outlying Islands",
    "emoji": "🇺🇲"
  },
  "United Nations": {
    "code": "UN",
    "unicode": "U+1F1FA U+1F1F3",
    "name": "United Nations",
    "emoji": "🇺🇳"
  },
  "United States": {
    "code": "US",
    "unicode": "U+1F1FA U+1F1F8",
    "name": "United States",
    "emoji": "🇺🇸"
  },
  "Uruguay": {
    "code": "UY",
    "unicode": "U+1F1FA U+1F1FE",
    "name": "Uruguay",
    "emoji": "🇺🇾"
  },
  "Uzbekistan": {
    "code": "UZ",
    "unicode": "U+1F1FA U+1F1FF",
    "name": "Uzbekistan",
    "emoji": "🇺🇿"
  },
  "Vatican City": {
    "code": "VA",
    "unicode": "U+1F1FB U+1F1E6",
    "name": "Vatican City",
    "emoji": "🇻🇦"
  },
  "St. Vincent & Grenadines": {
    "code": "VC",
    "unicode": "U+1F1FB U+1F1E8",
    "name": "St. Vincent & Grenadines",
    "emoji": "🇻🇨"
  },
  "Venezuela": {
    "code": "VE",
    "unicode": "U+1F1FB U+1F1EA",
    "name": "Venezuela",
    "emoji": "🇻🇪"
  },
  "British Virgin Islands": {
    "code": "VG",
    "unicode": "U+1F1FB U+1F1EC",
    "name": "British Virgin Islands",
    "emoji": "🇻🇬"
  },
  "U.S. Virgin Islands": {
    "code": "VI",
    "unicode": "U+1F1FB U+1F1EE",
    "name": "U.S. Virgin Islands",
    "emoji": "🇻🇮"
  },
  "Vietnam": {
    "code": "VN",
    "unicode": "U+1F1FB U+1F1F3",
    "name": "Vietnam",
    "emoji": "🇻🇳"
  },
  "Vanuatu": {
    "code": "VU",
    "unicode": "U+1F1FB U+1F1FA",
    "name": "Vanuatu",
    "emoji": "🇻🇺"
  },
  "Wallis & Futuna": {
    "code": "WF",
    "unicode": "U+1F1FC U+1F1EB",
    "name": "Wallis & Futuna",
    "emoji": "🇼🇫"
  },
  "Samoa": {
    "code": "WS",
    "unicode": "U+1F1FC U+1F1F8",
    "name": "Samoa",
    "emoji": "🇼🇸"
  },
  "Kosovo": {
    "code": "XK",
    "unicode": "U+1F1FD U+1F1F0",
    "name": "Kosovo",
    "emoji": "🇽🇰"
  },
  "Yemen": {
    "code": "YE",
    "unicode": "U+1F1FE U+1F1EA",
    "name": "Yemen",
    "emoji": "🇾🇪"
  },
  "Mayotte": {
    "code": "YT",
    "unicode": "U+1F1FE U+1F1F9",
    "name": "Mayotte",
    "emoji": "🇾🇹"
  },
  "South Africa": {
    "code": "ZA",
    "unicode": "U+1F1FF U+1F1E6",
    "name": "South Africa",
    "emoji": "🇿🇦"
  },
  "Zambia": {
    "code": "ZM",
    "unicode": "U+1F1FF U+1F1F2",
    "name": "Zambia",
    "emoji": "🇿🇲"
  },
  "Zimbabwe": {
    "code": "ZW",
    "unicode": "U+1F1FF U+1F1FC",
    "name": "Zimbabwe",
    "emoji": "🇿🇼"
  }
}